import Promise from 'bluebird';
import { Context, clientContextExecute } from 'itacs-spext-core';
import config from '@/config';
import { every } from '../central/enumerableExtensions';
import { CacheLayer } from '@/central';
var SearchSuggestionService = (function () {
    function SearchSuggestionService() {
        this.searchSuggestionListUrl = Context.instance.parseUrl(config.lists.searchSuggestionsList, true);
        this.ctx = new Promise(function (resolve) { return SP.SOD.executeFunc('sp.js', 'SP.ClientContext', function () { return resolve(new SP.ClientContext(_spPageContextInfo.webAbsoluteUrl)); }); });
    }
    Object.defineProperty(SearchSuggestionService, "instance", {
        get: function () {
            if (!this._instance) {
                this._instance = new SearchSuggestionService();
            }
            return this._instance;
        },
        enumerable: true,
        configurable: true
    });
    SearchSuggestionService.prototype.loadSearchResultUrl = function () {
        return this.ctx
            .then(function (ctx) {
            var props = ctx
                .get_site()
                .get_rootWeb()
                .get_allProperties();
            ctx.load(props);
            return clientContextExecute(ctx).then(function () {
                var value = JSON.parse(props.get_item('SRCH_SB_SET_SITE'));
                if (value.ResultsPageAddress) {
                    return value.ResultsPageAddress;
                }
                else {
                    throw 'SRCH_SB_SET_SITE not set';
                }
            });
        })
            .catch(function () {
            return Promise.resolve((_spPageContextInfo.siteServerRelativeUrl + '/Suche/Seiten/suchergebnisse.aspx').replace(/\/\//g, '/'));
        });
    };
    SearchSuggestionService.prototype.loadSearchSuggestionList = function () {
        var _this = this;
        return CacheLayer.simpleLoad(function () {
            return _this.ctx.then(function (ctx) {
                var list = ctx
                    .get_site()
                    .get_rootWeb()
                    .getList(_this.searchSuggestionListUrl);
                var query = SP.CamlQuery.createAllItemsQuery();
                var items = list.getItems(query);
                ctx.load(items);
                return clientContextExecute(ctx).then(function () {
                    var suggestions = [];
                    every(items, function (item) {
                        var suggestion = item.get_item('Title');
                        if (suggestion) {
                            suggestions = suggestions.concat([suggestion]);
                        }
                    });
                    return suggestions;
                });
            });
        }, 'loadSearchSuggestionList');
    };
    return SearchSuggestionService;
}());
export default SearchSuggestionService;
